import { signal } from "@preact/signals";

export const initSignal = signal(false);